module.exports = __webpack_public_path__ + "static/img/yy9.c667302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy9.png
// module id = txxD
// module chunks = 1